import { render, staticRenderFns } from "./compareData.vue?vue&type=template&id=52aed568&scoped=true&"
import script from "./compareData.vue?vue&type=script&lang=js&"
export * from "./compareData.vue?vue&type=script&lang=js&"
import style0 from "./compareData.vue?vue&type=style&index=0&id=52aed568&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aed568",
  null
  
)

export default component.exports